import { Select, SelectChangeEvent } from "@parspec/pixel";
import { memo } from "react";

export const VIEW_OPTIONS = {
    SECTION: 'Section',
    MANUFACTURER: 'Manufacturer',
} as const;

export type ViewOptionValues = typeof VIEW_OPTIONS[keyof typeof VIEW_OPTIONS];
type SelectParams = Parameters<typeof Select>[0];

interface ViewBySelectProps extends Omit<SelectParams, 'options' | 'label' | 'labelId'> {
    value: ViewOptionValues;
    onChange: (e: SelectChangeEvent<ViewOptionValues>) => void;
}

const OPTIONS = Object.values(VIEW_OPTIONS).map((value: string) => ({
    label: value,
    value,
}));

function ViewBySelect(props: ViewBySelectProps) {
    return (
        <Select
            {...props}
            options={OPTIONS}
            label="View by"
            labelId="view-by-table-select-label"
        />
    )
};

export default memo(ViewBySelect);